import {
} from "@comp";

import HTMLTooltip from "./HTMLTooltip.vue";
import {
    buildLimitations
} from "./utils";
import { buildPanelColumns } from "./panelColumns.js";

export default function (store, { bulkSelection = false, variant = null } = {}) {
    const isMilitary = variant?.key === "military";
    const panelColumns = buildPanelColumns(store.state["Matrices/SignatoryMatrix/Panels"], { isMilitary });

    return {
        tooltipInteraction: true,
        tooltipShowDelay: 0,
        suppressHorizontalScroll: false,
        ...(bulkSelection ? {
            rowSelection: {
                mode: "multiRow",
                checkboxes: true,
                headerCheckbox: true,
                selectAll: "all",
                enableClickSelection: false
            },
            selectionColumnDef: {
                pinned: "left",
                width: 48,
                maxWidth: 48,
                suppressHeaderMenuButton: true,
                sortable: false,
                resizable: false
            }
        } : {}),
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            cellDataType: false,
            suppressFieldDotNotation: false,
            useValueFormatterForExport: true,
            useValueParserForImport: true,
            tooltipComponent: HTMLTooltip,
            tooltipShowDelay: 0,
            tooltipInteraction: true
        },
        columnDefs: [{
            headerName: "Person",
            children: [{
                headerName: "Number",
                field: "CSR",
                pinned: "left",
                width: 70,
                filter: 'agNumberColumnFilter',
                type: "number",
                sort: "desc",
                sortIndex: 0
                
            }, {
                headerName: "Name",
                field: "Name",
                pinned: "left",
            }, {
                headerName: "Internal",
                field: "IsInternal",
                pinned: "left",
                width: 70,
                valueFormatter(params) {
                    return params.data.IsInternal ? "Yes" : "No";
                }
            }, 
            // {
            //     headerName: "User Sign-Off",
            //     field: "UserSignOff",
            //     pinned: "left",
            //     width: 105,
            //     valueFormatter(params) {
            //         const v = params.data.UserSignOff;
            //         if (v === true) return "Signed";
            //         if (v === false) return "Pending";
            //         return "—";
            //     },
            //     cellStyle(params) {
            //         const v = params.data.UserSignOff;
            //         if (v === true) {
            //             return { color: "#166534", fontWeight: 600 };
            //         }
            //         if (v === false) {
            //             return { color: "#c2410f", fontWeight: 600 };
            //         }
            //         return null;
            //     }
            // }, 
            {
                headerName: "Limitations",
                field: "Limitations",
                pinned: "left",
                type: "html",
                valueFormatter(params) {
                    return "Hover / Click to see limitations";
                },
                tooltipValueGetter(params) {
                    return buildLimitations(params.data, store);
                }
 
            }]
        }, {
            headerName: "Discipline: Areas of Expertise",
            children: panelColumns
        }]
    };
};
